// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchPage_container__2a8_u"};